module.exports = __webpack_public_path__ + "static/media/import-file.523847fb.svg";